import { Link } from "react-router-dom";
import { ArrowUpRight, ChefHat, Bath, Home as HomeIcon } from "lucide-react";

const SERVICES = [
  {
    icon: ChefHat,
    title: "Kitchen Remodels",
    image: "/photos/wellesley/kitchen/13.jpg",
    desc: "From a straightforward kitchen renovation to a fully reimagined open-plan space. We handle all your cabinetry, countertop and finish carpentry needs from start-to-finish.",
    range: "Typical investment $60k – $150k+",
    inclusions: ["Custom or semi-custom cabinetry", "Slab quartz, quartzite & marble", "Integrated paneled appliances", "Lighting & electrical", "Tile & stone backsplashes", "Walls down / structural opens"],
  },
  {
    icon: Bath,
    title: "Bathroom Remodels",
    image: "/photos/services/bathroom_white_freestanding.jpg",
    desc: "Spa-style primary baths, dialed-in guest baths, and powder rooms with real personality. Heated floors, curbless showers, the works.",
    range: "Typical investment $35k – $50k+",
    inclusions: ["Curbless / wet-room shower builds", "Heated tile floors", "Custom vanities & lighting", "Soaking & freestanding tubs", "Tile, stone & slab walls", "Plumbing rough-in reroutes"],
  },
  {
    icon: HomeIcon,
    title: "Whole-Home Renovations",
    image: "/photos/services/whole_home_living_v2.jpg",
    desc: "A coordinated remodel of multiple spaces — usually kitchen, primary bath, and one or two other rooms — on a single project schedule.",
    range: "Typical investment $150k – $500k+",
    inclusions: ["Kitchen + multiple baths", "Mudrooms, laundry, butler's pantries", "Lighting & finishes throughout", "Flooring & millwork", "Structural opens & additions", "Single PM, single calendar"],
  },
];

export default function Services() {
  return (
    <div>
      <section className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 pt-20 md:pt-28 pb-12">
        <div className="text-xs tracking-[0.3em] uppercase text-zinc-500">Services</div>
        <h1 className="font-display text-5xl md:text-7xl font-light tracking-tight mt-4 max-w-5xl leading-[1.0]">
          Three things,<br />done very well.
        </h1>
        <p className="text-zinc-600 max-w-2xl mt-8 leading-relaxed text-lg">
          Kitchens, bathrooms and whole-home renovations — done right and done with great pride.
          We&apos;ve spent over 27 years getting good at exactly that.
        </p>
      </section>

      {SERVICES.map((s, i) => {
        const Icon = s.icon;
        return (
          <section key={s.title} className={`mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-16 md:py-24 ${i % 2 === 1 ? "" : ""}`} data-testid={`service-${i}`}>
            <div className={`grid lg:grid-cols-12 gap-10 lg:gap-16 items-center ${i % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
              <div className={`lg:col-span-7 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <img src={s.image} alt={s.title} className="w-full h-[55vh] object-cover" />
              </div>
              <div className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                <Icon size={28} />
                <h2 className="font-display text-4xl md:text-5xl font-light mt-6 tracking-tight">{s.title}</h2>
                <p className="text-zinc-700 mt-5 leading-relaxed">{s.desc}</p>
                <div className="text-xs tracking-[0.25em] uppercase text-zinc-500 mt-6">{s.range}</div>
                <ul className="grid grid-cols-2 gap-x-6 gap-y-2 mt-6 text-sm text-zinc-700">
                  {s.inclusions.map((x) => <li key={x} className="border-t border-zinc-200 py-2">{x}</li>)}
                </ul>
                <Link to="/booking" className="inline-flex items-center gap-2 mt-8 bg-zinc-950 text-white px-6 py-3 text-sm hover:bg-zinc-800 transition" data-testid={`service-cta-${i}`}>
                  Discuss your project <ArrowUpRight size={14} />
                </Link>
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
}
